import { Download, ManageHistory } from "@mui/icons-material"
import { Button, Collapse } from "@mui/material"
import classNames from "classnames"
import React, { useEffect, useState } from "react"
import { useMutation, useQueryClient } from "react-query"
import { toast } from "react-toastify"





import CustomModal from "../../../shared/CustomModal"
import { CustomButton } from "../../../shared/CustomButton"
import CustomInput from "../../../shared/CustomInput"
import axiosInstance from "../../../config/axios"
import { API_URLS } from "../../../config/apiUrls"
import { addSpecificationTypesByExcal } from "../../../Services/SpecificationTypes/SpecificationByExcal"


const AddSpecificationValueByExcel = ({ className }) => {
    const [open, setOpen] = useState(false)
    const [file, setFile] = useState(null)
    const [status, setStatus] = useState({})
    const [isUpate, setIsUpdate] = useState(false)

    const handleClose = () => {
        setOpen(false)
        setIsUpdate(false)
    }
    const handleOpen = () => setOpen(true)
    const client = useQueryClient()

    const { mutate: addSpeciByExcel, isLoading } = useMutation(addSpecificationTypesByExcal, {
        onSuccess: (response) => {
            if (response.data.response_code === 200) {
                toast.success(response.data.message)
                client.refetchQueries("specifications_values")
                handleClose()
            }
        },
    })
    const { mutate: updateCustomerByExcel, isLoading: isLoadingUpdate } = useMutation(() => { }, {
        onSuccess: (response) => {
            if (response.data.response_code === 200) {
                toast.success(response.data.message)
                client.refetchQueries("customer")
                handleClose()
            }
        },
    })
    const handleSendRequest = async () => {
        try {
            const response = await axiosInstance.post("export-customer-data-api-of-bhaaraterp/", {})
            if (response.data.response_code === 200) {
                toast.success(response.data.message)
                handleStatus()
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            console.error("Error:", error)
        }
    }

    const handleStatus = async () => {
        try {
            const response = await axiosInstance.get("export-customer-data-api-of-bhaaraterp/")
            setStatus(response?.data)
        } catch (error) {
            console.error("Error:", error)
        }
    }
    useEffect(() => {
        isUpate && handleStatus()
    }, [isUpate])

    const handleExport = async () => {
        status.file_url ? window.open(status.file_url) : toast.info(status.message)
    }

    const reqBody = new FormData()
    reqBody.append("file", file)
    // reqBody.append("file_type", "Customer")

    const handleSubmitAdd = (event) => {
        event.preventDefault()
        addSpeciByExcel(reqBody)
    }
    const handleSubmitUpdate = (event) => {
        event.preventDefault()
        updateCustomerByExcel(reqBody)
    }

    const handleDownload = async () => {
        try {
            const response = await axiosInstance.post(
                API_URLS.generate_specification_value,
                {},
                { responseType: "blob" }
            )
            if (!response) {
                throw new Error("Failed to upload product variant data")
            }
            const url = URL.createObjectURL(response.data)
            const a = document.createElement("a")
            a.href = url
            a.download = "sample_specification_data.xlsx"
            a.click()
            URL.revokeObjectURL(url)
        } catch (error) {
            console.error("Error:", error)
            toast.error(error)
        }
    }

    return (
        <>
            <Button variant="outlined" startIcon={<ManageHistory className="!text-base" />} onClick={handleOpen} className={className}>
                Excel
            </Button>
            <CustomModal
                title="Manage Specification Types By Excel"
                open={open}
                padding={0}
                onClose={handleClose}
                className="!w-1/3 !max-h-[80%] !min-h-[40%] pb-7 overflow-y-auto"
            >
                <div className="flex items-center gap-2 p-2">
                    {/* <CustomButton
                        onClick={() => setIsUpdate(false)}
                        className={classNames("w-full", !isUpate && "bg-gradient-to-r !text-white from-cyan-500 to-blue-500")}
                    >
                        Add
                    </CustomButton> */}
                    {/* <CustomButton
                        className={classNames("w-full", isUpate && "bg-gradient-to-r !text-white from-cyan-500 to-blue-500")}
                        onClick={() => setIsUpdate(true)}
                    >
                        Update Customer
                    </CustomButton> */}
                </div>
                <Collapse in={!isUpate}>
                    <form onSubmit={handleSubmitAdd} className="flex flex-col justify-center gap-3 p-5">
                        <span className="flex items-center justify-end w-full py-2">
                            <Button startIcon={<Download />} onClick={() => handleDownload()}>
                                Download Sample
                            </Button>
                        </span>
                        <CustomInput
                            label="Upload Updated Excel"
                            type="file"
                            className="w-full rounded p-1 border border-gray-500 !bg-white !bg-opacity-20"
                            onChange={(event) => setFile(event.target.files[0])}
                        />

                        <Button variant="outlined" isLoading={isLoading} type="submit" className="my-3 !min-w-full">
                            Add
                        </Button>
                    </form>
                </Collapse>
                <Collapse in={isUpate}>
                    <form onSubmit={handleSubmitUpdate} className="flex flex-col justify-center gap-3 p-5">
                        <span className="flex flex-col w-full gap-5 py-2">
                            <CustomButton onClick={() => handleSendRequest()}>Request for Export</CustomButton>
                            {status.message}
                            <CustomButton
                                startIcon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0px"
                                        y="0px"
                                        width="100"
                                        height="100"
                                        viewBox="0 0 24 24"
                                        className="w-5 h-5"
                                    >
                                        <g fill="#279b3e">
                                            <path d="M 12 3 L 2 5 L 2 19 L 12 21 L 12 3 z M 14 5 L 14 7 L 16 7 L 16 9 L 14 9 L 14 11 L 16 11 L 16 13 L 14 13 L 14 15 L 16 15 L 16 17 L 14 17 L 14 19 L 22 19 L 22 5 L 14 5 z M 18 7 L 20 7 L 20 9 L 18 9 L 18 7 z M 4.1757812 8.296875 L 5.953125 8.296875 L 6.8769531 10.511719 C 6.9519531 10.692719 7.0084063 10.902625 7.0664062 11.140625 L 7.0917969 11.140625 C 7.1247969 10.997625 7.1919688 10.779141 7.2929688 10.494141 L 8.3222656 8.296875 L 9.9433594 8.296875 L 8.0078125 11.966797 L 10 15.703125 L 8.2714844 15.703125 L 7.1582031 13.289062 C 7.1162031 13.204062 7.0663906 13.032922 7.0253906 12.794922 L 7.0097656 12.794922 C 6.9847656 12.908922 6.934375 13.079594 6.859375 13.308594 L 5.7363281 15.703125 L 4 15.703125 L 6.0605469 11.996094 L 4.1757812 8.296875 z M 18 11 L 20 11 L 20 13 L 18 13 L 18 11 z M 18 15 L 20 15 L 20 17 L 18 17 L 18 15 z"></path>
                                        </g>
                                    </svg>
                                }
                                onClick={handleExport}
                            >
                                Export Customer Data
                            </CustomButton>
                        </span>

                        <CustomInput
                            label="Upload Updated Excel"
                            type="file"
                            className="w-full rounded p-1 border border-gray-500 !bg-white !bg-opacity-20"
                            onChange={(event) => setFile(event.target.files[0])}
                        />

                        <CustomButton isLoading={isLoadingUpdate} type="submit" className="my-3 !min-w-full">
                            Update Customer
                        </CustomButton>
                    </form>
                </Collapse>
            </CustomModal>
        </>
    )
}

export default AddSpecificationValueByExcel
